import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "./use-toast";

export interface SapSyncResult {
	sapSync?: {
		status: "synced" | "failed" | "queued" | "skipped";
		error?: string;
		reason?: "multi_alternative" | "lead_without_company" | "already_in_progress";
	} | null;
}

export function useSapSyncToast(
	scope: "document" | "partner" = "document",
	savedKey = "updateSuccess",
): (result: SapSyncResult) => void {
	const { t } = useTranslation();
	const prefix = scope === "partner" ? "sapSyncPartner" : "sapSync";
	const { showToast } = useToast();
	return useCallback(
		(result: SapSyncResult) => {
			const sync = result?.sapSync;
			if (sync?.reason === "multi_alternative") {
				showToast(t(`${prefix}.multiAlternative`), "success");
			} else if (sync?.reason === "lead_without_company") {
				showToast(t(`${prefix}.leadWithoutCompany`), "error");
			} else if (sync?.reason === "already_in_progress") {
				showToast(t(`${prefix}.alreadyInProgress`), "success");
			} else if (!sync || sync.status === "skipped") {
				showToast(t(savedKey), "success");
			} else if (sync.status === "synced") {
				showToast(t(`${prefix}.synced`), "success");
			} else if (sync.status === "queued") {
				showToast(t(`${prefix}.queued`), "success");
			} else {
				showToast(`${t(`${prefix}.failed`)}${sync.error ? `: ${sync.error}` : ""}`, "error");
			}
		},
		[showToast, t, prefix, savedKey],
	);
}
